import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\PodcastBoostController::create
* @see app/Http/Controllers/PodcastBoostController.php:27
* @route '/podcast-boost'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/podcast-boost',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PodcastBoostController::create
* @see app/Http/Controllers/PodcastBoostController.php:27
* @route '/podcast-boost'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PodcastBoostController::create
* @see app/Http/Controllers/PodcastBoostController.php:27
* @route '/podcast-boost'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PodcastBoostController::create
* @see app/Http/Controllers/PodcastBoostController.php:27
* @route '/podcast-boost'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PodcastBoostController::store
* @see app/Http/Controllers/PodcastBoostController.php:62
* @route '/podcast-boost'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/podcast-boost',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\PodcastBoostController::store
* @see app/Http/Controllers/PodcastBoostController.php:62
* @route '/podcast-boost'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PodcastBoostController::store
* @see app/Http/Controllers/PodcastBoostController.php:62
* @route '/podcast-boost'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\PodcastBoostController::catalogue
* @see app/Http/Controllers/PodcastBoostController.php:112
* @route '/podcast-boost/catalogue'
*/
export const catalogue = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: catalogue.url(options),
    method: 'get',
})

catalogue.definition = {
    methods: ["get","head"],
    url: '/podcast-boost/catalogue',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PodcastBoostController::catalogue
* @see app/Http/Controllers/PodcastBoostController.php:112
* @route '/podcast-boost/catalogue'
*/
catalogue.url = (options?: RouteQueryOptions) => {
    return catalogue.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PodcastBoostController::catalogue
* @see app/Http/Controllers/PodcastBoostController.php:112
* @route '/podcast-boost/catalogue'
*/
catalogue.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: catalogue.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PodcastBoostController::catalogue
* @see app/Http/Controllers/PodcastBoostController.php:112
* @route '/podcast-boost/catalogue'
*/
catalogue.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: catalogue.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PodcastBoostController::report
* @see app/Http/Controllers/PodcastBoostController.php:152
* @route '/podcast-boost/report'
*/
export const report = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: report.url(options),
    method: 'post',
})

report.definition = {
    methods: ["post"],
    url: '/podcast-boost/report',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\PodcastBoostController::report
* @see app/Http/Controllers/PodcastBoostController.php:152
* @route '/podcast-boost/report'
*/
report.url = (options?: RouteQueryOptions) => {
    return report.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PodcastBoostController::report
* @see app/Http/Controllers/PodcastBoostController.php:152
* @route '/podcast-boost/report'
*/
report.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: report.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\PodcastBoostController::status
* @see app/Http/Controllers/PodcastBoostController.php:22
* @route '/podcast-boost/status'
*/
export const status = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: status.url(options),
    method: 'get',
})

status.definition = {
    methods: ["get","head"],
    url: '/podcast-boost/status',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PodcastBoostController::status
* @see app/Http/Controllers/PodcastBoostController.php:22
* @route '/podcast-boost/status'
*/
status.url = (options?: RouteQueryOptions) => {
    return status.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PodcastBoostController::status
* @see app/Http/Controllers/PodcastBoostController.php:22
* @route '/podcast-boost/status'
*/
status.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: status.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PodcastBoostController::status
* @see app/Http/Controllers/PodcastBoostController.php:22
* @route '/podcast-boost/status'
*/
status.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: status.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PodcastBoostController::mine
* @see app/Http/Controllers/PodcastBoostController.php:138
* @route '/podcast-boost/mine'
*/
export const mine = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: mine.url(options),
    method: 'get',
})

mine.definition = {
    methods: ["get","head"],
    url: '/podcast-boost/mine',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PodcastBoostController::mine
* @see app/Http/Controllers/PodcastBoostController.php:138
* @route '/podcast-boost/mine'
*/
mine.url = (options?: RouteQueryOptions) => {
    return mine.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\PodcastBoostController::mine
* @see app/Http/Controllers/PodcastBoostController.php:138
* @route '/podcast-boost/mine'
*/
mine.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: mine.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PodcastBoostController::mine
* @see app/Http/Controllers/PodcastBoostController.php:138
* @route '/podcast-boost/mine'
*/
mine.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: mine.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PodcastBoostController::show
* @see app/Http/Controllers/PodcastBoostController.php:78
* @route '/podcast-boost/{order}'
*/
export const show = (args: { order: string | number | { public_id: string | number } } | [order: string | number | { public_id: string | number } ] | string | number | { public_id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '/podcast-boost/{order}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\PodcastBoostController::show
* @see app/Http/Controllers/PodcastBoostController.php:78
* @route '/podcast-boost/{order}'
*/
show.url = (args: { order: string | number | { public_id: string | number } } | [order: string | number | { public_id: string | number } ] | string | number | { public_id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { order: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'public_id' in args) {
        args = { order: args.public_id }
    }

    if (Array.isArray(args)) {
        args = {
            order: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        order: typeof args.order === 'object'
        ? args.order.public_id
        : args.order,
    }

    return show.definition.url
            .replace('{order}', parsedArgs.order.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\PodcastBoostController::show
* @see app/Http/Controllers/PodcastBoostController.php:78
* @route '/podcast-boost/{order}'
*/
show.get = (args: { order: string | number | { public_id: string | number } } | [order: string | number | { public_id: string | number } ] | string | number | { public_id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\PodcastBoostController::show
* @see app/Http/Controllers/PodcastBoostController.php:78
* @route '/podcast-boost/{order}'
*/
show.head = (args: { order: string | number | { public_id: string | number } } | [order: string | number | { public_id: string | number } ] | string | number | { public_id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\PodcastBoostController::action
* @see app/Http/Controllers/PodcastBoostController.php:96
* @route '/podcast-boost/{order}/action'
*/
export const action = (args: { order: string | number | { public_id: string | number } } | [order: string | number | { public_id: string | number } ] | string | number | { public_id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: action.url(args, options),
    method: 'post',
})

action.definition = {
    methods: ["post"],
    url: '/podcast-boost/{order}/action',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\PodcastBoostController::action
* @see app/Http/Controllers/PodcastBoostController.php:96
* @route '/podcast-boost/{order}/action'
*/
action.url = (args: { order: string | number | { public_id: string | number } } | [order: string | number | { public_id: string | number } ] | string | number | { public_id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { order: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'public_id' in args) {
        args = { order: args.public_id }
    }

    if (Array.isArray(args)) {
        args = {
            order: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        order: typeof args.order === 'object'
        ? args.order.public_id
        : args.order,
    }

    return action.definition.url
            .replace('{order}', parsedArgs.order.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\PodcastBoostController::action
* @see app/Http/Controllers/PodcastBoostController.php:96
* @route '/podcast-boost/{order}/action'
*/
action.post = (args: { order: string | number | { public_id: string | number } } | [order: string | number | { public_id: string | number } ] | string | number | { public_id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: action.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\PodcastBoostController::confirm
* @see app/Http/Controllers/PodcastBoostController.php:68
* @route '/podcast-boost/{order}/confirm'
*/
export const confirm = (args: { order: string | number | { public_id: string | number } } | [order: string | number | { public_id: string | number } ] | string | number | { public_id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: confirm.url(args, options),
    method: 'post',
})

confirm.definition = {
    methods: ["post"],
    url: '/podcast-boost/{order}/confirm',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\PodcastBoostController::confirm
* @see app/Http/Controllers/PodcastBoostController.php:68
* @route '/podcast-boost/{order}/confirm'
*/
confirm.url = (args: { order: string | number | { public_id: string | number } } | [order: string | number | { public_id: string | number } ] | string | number | { public_id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { order: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'public_id' in args) {
        args = { order: args.public_id }
    }

    if (Array.isArray(args)) {
        args = {
            order: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        order: typeof args.order === 'object'
        ? args.order.public_id
        : args.order,
    }

    return confirm.definition.url
            .replace('{order}', parsedArgs.order.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\PodcastBoostController::confirm
* @see app/Http/Controllers/PodcastBoostController.php:68
* @route '/podcast-boost/{order}/confirm'
*/
confirm.post = (args: { order: string | number | { public_id: string | number } } | [order: string | number | { public_id: string | number } ] | string | number | { public_id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: confirm.url(args, options),
    method: 'post',
})

const PodcastBoostController = { create, store, catalogue, report, status, mine, show, action, confirm }

export default PodcastBoostController